export default __webpack_public_path__ + "static/media/transact.305a49da.jpg";